import warning from "rc-util/es/warning";
export default (function (valid, component, message) {
  warning(valid, "[antd-compatible: ".concat(component, "] ").concat(message));
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_compatible@1.0.2@@ant-design/compatible/es/_util/warning.js
// module id = 90
// module chunks = 0